import routerOptions0 from "/frontend/node_modules/.pnpm/nuxt@3.16.1_@parcel+watcher@2.4.1_@types+node@25.0.3_db0@0.3.1_eslint@9.34.0_jiti@2.6.1_3de35219f66c5c759f7a3a4948af7cfa/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "smooth"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}